import styled from '@emotion/styled';

import { withTheme } from 'emotion-theming';

import { disabledColor, errorColor, successColor, white } from '@zego/theme';

const Input = styled('input')(
  {
    borderRadius: 4,
    backgroundColor: white,
    padding: '11px 0 11px 50px',
    color: disabledColor(10),
    fontSize: 28,
    lineHeight: '28px',
    fontWeight: 900,
    margin: 0,
    width: '100%',
    '&::placeholder': {
      color: disabledColor(4),
      lineHeight: 'normal',
    },
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
    '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  },
  props => ({
    textTransform: props.textTransform || 'none',
    border: `1px solid ${props.error ? errorColor(5) : disabledColor(4)}`,
    '&:focus': {
      outline: 'none',
      padding: '10px 0 10px 49px',
      border: `2px solid ${props.theme.tintColor || successColor(5)}`,
    },
  }),
);

export default withTheme(Input);
